const config = {
  // API_ENDPOINT: "http://localhost:8000/api",
  TOKEN_KEY: process.env.REACT_APP_API_KEY,
  API_ENDPOINT: " https://stormy-dawn-55910.herokuapp.com/api",
};

export default config;
